import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { FormWrapperDiv } from 'libs/forms/styles';
import { confToFields } from 'libs/forms';
import Spinner from 'components/Spinner';
import { NewMonthlyTotal } from 'apps/payment/views/newMonthlyTotal';
import { DueToday } from 'apps/payment/views/dueToday';

import { BannerStyled } from 'apps/payment/styles';

@withNamespaces()
@observer
export class SubscriptionCheckout extends React.Component {
  render() {
    const {
      coupon,
      paymentSpacePreview,
      children,
      allowAddSeats,
      actionable = true,
      noPadding = true,
    } = this.props;

    if (!(paymentSpacePreview && paymentSpacePreview.preview)) {
      return <Spinner margin='30px auto 10px' />;
    }

    const { preview, form } = paymentSpacePreview;
    const { discountApplied, subscribing } = preview;

    const couponMessage =
      coupon &&
      (discountApplied ? (
        <BannerStyled variant='success'>
          <Trans>
            Coupon &quot;{{ coupon }}&quot; applied succesfully. Enjoy!
          </Trans>
        </BannerStyled>
      ) : (
        <BannerStyled variant='warning'>
          <Trans>Coupon invalid. No discount applied.</Trans>
        </BannerStyled>
      ));

    const refs = {};
    const fields = confToFields({ formStore: form, refs });

    return (
      <FormWrapperDiv posting={subscribing} noPadding={noPadding}>
        {couponMessage}
        <NewMonthlyTotal
          paymentSpacePreview={paymentSpacePreview}
          allowAddSeats={allowAddSeats}
        />
        <DueToday paymentSpacePreview={paymentSpacePreview} />
        {actionable && fields}
        {children}
      </FormWrapperDiv>
    );
  }
}

SubscriptionCheckout.propTypes = {
  paymentSpacePreview: PropTypes.object,
  coupon: PropTypes.string,
  children: PropTypes.node,
  noPadding: PropTypes.bool,
  allowAddSeats: PropTypes.bool,
  actionable: PropTypes.bool,
};
